module.exports = __webpack_public_path__ + "static/img/logo26.9a3ef6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo26.png
// module id = 22j/
// module chunks = 1